module.exports = __webpack_public_path__ + "img/right-arrow.ca784f5f.svg";